











import { Component, Prop, Vue } from "vue-property-decorator";
import EventPublicCalendar from "@/components/EventPublicCalendar.vue";

@Component({ components: { EventPublicCalendar } })
export default class EventCalendar extends Vue {
    @Prop() ym!: string;
    @Prop() userId!: string;
}
